import moment from 'moment'

export default {
  install (Vue) {
    /**
     * Show a date in a pretty format.
     *
     * @return string
     */
    Vue.filter('date', (value, format = 'DD/MM/YYYY', utc = true) => {
      let date = moment(value)

      if (utc) {
        date = moment.utc(value)
      }

      if (!date.isValid() || !value) {
        return
      }

      return date.local().format(format)
    })

    Vue.filter('localDate', (value, format = 'DD/MM/YYYY') => {
      let date = moment(value)

      if (!date.isValid() || !value) {
        return
      }

      return date.local().format(format)
    })
  }
}
